document.addEventListener('DOMContentLoaded', async function () {
  try {
    const res = await fetch('https://apps.usfa.fema.gov/nfacourses/api/status/applicationPeriod');

    if (!res.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await res?.json()

    const alive = document.querySelector('#alive');
      alive.classList.remove('d-none');

    if (data.status === 'open') {
      const status = document.querySelector('#open');
      status.classList.remove('d-none');
      const periodStart = document.querySelector('#appPeriodStart');
      periodStart.textContent = data.appPeriodStart;
      const periodEnd = document.querySelector('#appPeriodEnd');
      periodEnd.textContent = data.appPeriodEnd;
      const schedule = document.querySelector('#courseSchedule');
      schedule.textContent = data.courseSchedule;
      const link = document.querySelector('#link a');
      link.href = data.link;
    }

    if (data.status === 'closed') {
      const status = document.querySelector('#closed');
      status.classList.remove('d-none');
    }

  } catch (error) {
    throw new Error(error)
  }
});
